import React, { useEffect } from 'react'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import UserDetails from './UserDetails'
import TimeLine from './TimeLine';
import UserIntrest from './UserIntrest';
import LeadMetaData from './LeadMetaData';
import UserActions from './UserActions';
import NoteHistory from './NoteHistory';
import LeadSummry from './LeadSummry';
import RequestSchedule from './RequestSchedule';
import ReeceivedRequest from './ReeceivedRequest';
import { useNotification } from '../../hooks/useNotification';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchWebLeadDetails } from '../../api/webLeadsApi';
import { BackArrowIcon, } from '../../icons';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { IconButton } from '@mui/material';


const LeadDetails = ({ backUrl }) => {
    const [loading, setLoading] = React.useState(true);
    const [details, setDetails] = React.useState(null);
    const { leadId } = useParams()
    const { showSuccessNotification, showErrorNotification, } = useNotification()
    const userAuth = useSelector(state => state?.auth)
    const navigate = useNavigate();
    const location = useLocation();
    const resolvedBackUrl = location.state?.backUrl || backUrl;

    const fetchDetails = () => {
        fetchWebLeadDetails({ leadId, setDetails, setLoading })
            .catch(error => {
                showErrorNotification(error?.message)
            })
    }

    useEffect(() => {
        fetchDetails()
    }, [])

    const handleBack = (e) => {
        e.preventDefault();
        if (resolvedBackUrl === -1) {
            navigate(-1);
        } else if (typeof resolvedBackUrl === 'string') {
            navigate(resolvedBackUrl, { state: { backUrl: location?.pathname, activeTab: location?.state?.activeTab } });
        } else {
            navigate(-1);
        }
    };


    return (
        <>
            <Box sx={{ padding: '17px' }} >
                <div className="col">
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#15243E',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <IconButton onClick={handleBack} size="small" aria-label="Back">
                            <BackArrowIcon />
                        </IconButton>
                        Lead Details
                    </Typography>
                </div>
                <Grid container spacing={2}>
                    <Grid size={8}>
                        <UserDetails details={details} />
                        <Grid container spacing={2}>
                            <Grid size={7}>
                                <TimeLine journeys={details?.user_journeys} />
                            </Grid>
                            <Grid size={5}>
                                <UserIntrest interests={details?.user_interest} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <LeadMetaData metaData={details?.metaData} details={details} />
                            </Grid>

                        </Grid>

                    </Grid>
                    <Grid size={4}>
                        <ReeceivedRequest details={details}/>
                        <UserActions  details={details} refetch={fetchDetails}/>
                        <NoteHistory details={details}/>
                        <LeadSummry details={details}/>
                        {/* <RequestSchedule/> */}
                    </Grid>
                </Grid>
            </Box>


        </>
    )
}

export default LeadDetails